<script setup>

import HeroComponent from "@/components/homepage/hero-component.vue";
import AboutUsComponent from "@/components/homepage/aboutUs-component.vue";
import BenefitsComponent from "@/components/homepage/benefits-component.vue";
import TrustComponent from "@/components/homepage/trust-component.vue";
import ContactComponent from "@/components/homepage/contact-component.vue";
</script>

<template>
  <hero-component />
  <about-us-component />
  <benefits-component />
  <trust-component />
  <contact-component />
</template>

<style scoped>

</style>